import React from "react";
import moment from 'moment';

import {
  formatRiderPhone,
  formatRiderStatus,
  riderPhoneHref,
  RIDER_STATUS_IN_TRANSIT,
} from "../utils";

// Pendant de UberDeliveries (spec 008) : les trois colonnes livreur d'une
// commande Deliveroo. Pas de véhicule — Deliveroo n'en envoie pas.
const NO_ARRIVAL_AFTER = [RIDER_STATUS_IN_TRANSIT, 'rider_unassigned'];

// Le pont d'abord : Deliveroo masque le livreur derrière un numéro commun
// et un code par livreur. Son `contact_number` n'en est que la
// concaténation (« 33175858369 (153221077) »), illisible telle quelle.
const riderNumber = (delivery) => {
  const number = delivery.bridge_number || delivery.delivery_partner_phone_number;
  const code = delivery.bridge_number ? delivery.bridge_code : null;
  const label = formatRiderPhone(number);
  if (!label) {
    return '-';
  }
  return (
    <>
      <a href={riderPhoneHref(number, code)}>{label}</a>
      {code && <div style={{ fontSize: '0.85em' }}>code {code}</div>}
    </>
  );
};

const DeliverooRider = ({ deliveries }) => {
  const delivery = deliveries[0];
  const showArrival = delivery.estimated_arrival_time
    && !NO_ARRIVAL_AFTER.includes(delivery.status);

  return (
    <>
      <td>
        {delivery.delivery_partner_name || '-'}
      </td>
      <td>
        {riderNumber(delivery)}
      </td>
      <td>
        {formatRiderStatus(delivery.status)}
        {showArrival && (
          <div style={{ fontSize: '0.85em', opacity: 0.8 }}>
            arrivée ~{moment(delivery.estimated_arrival_time).format('HH:mm')}
          </div>
        )}
      </td>
    </>
  );
};

export default DeliverooRider;
